<script setup lang="ts">
import { useNuxtApp } from "#app";
import { computed } from "vue";
import { ResizeType } from "@bitpatty/imgproxy-url-builder";

const props = defineProps({
    content: Object,
    title: String,
});

const nuxtApp = useNuxtApp();
const text = computed(() => props.content?.text ? nuxtApp.marked(true, {desktopImageWidth: 200}).parse(props.content?.text) : '');
const changePosition = computed(() => props.content?.changePosition);
</script>

<template>
    <article class="max-w-2xl px-6 mx-auto space-y-4 prose article-fact content-image-text"
             :class="{'image-left': !changePosition, 'image-right': changePosition}"
             v-html="text"
    ></article>
</template>